<template>
  <section v-if="dreetsFiles && dreetsFiles.length > 0">
    <h2 id="dreets-title">Documents de la DREETS</h2>
    <TableFull
      no-caption
      title="Documents de la DREETS"
      :headers="headers"
      :data="dreetsFiles"
    />
  </section>
  <section v-if="ovaFiles && ovaFiles.length > 0">
    <h2 id="ova-title">Documents de l'OVA</h2>
    <TableFull
      no-caption
      title="Documents de l'OVA"
      :headers="headers"
      :data="ovaFiles"
    />
  </section>
  <section v-if="ovaFiles.length === 0 && dreetsFiles.length === 0">
    Aucun document joint
  </section>
</template>

<script setup lang="ts">
import { computed } from "vue";
import TableFull from "../../components/Table/TableFull.vue";
import {
  type AgrementFilesDto,
  type DocumentDto,
  formatFRDateTime,
  getFileCategoryLabel,
} from "@vao/shared-bridge";

const props = defineProps({
  agrement: { type: Object, required: true },
  cdnUrl: { type: String, required: true },
});

const dreetsFiles = computed(
  () =>
    props.agrement?.agrementFiles?.filter(
      (agrementFile: DocumentDto) => agrementFile.userId === null,
    ) ?? [],
);

const ovaFiles = computed(
  () =>
    props.agrement?.agrementFiles?.filter(
      (agrementFile: DocumentDto) => agrementFile.userId !== null,
    ) ?? [],
);

const headers = [
  {
    column: "name",
    sorter: "name",
    text: "Nom du fichier",
    headerAttrs: {
      class: "suivi",
    },
  },
  {
    column: "category",
    sorter: "category",
    text: "Type de fichier",
    format: (item: AgrementFilesDto) => getFileCategoryLabel(item.category!),
    headerAttrs: {
      class: "suivi",
    },
  },
  {
    column: "createdAt",
    sorter: "createdAt",
    format: (item: DocumentDto) => formatFRDateTime(item.createdAt!),
    text: "Date de dépose",
    headerAttrs: {
      class: "suivi",
    },
  },
  {
    text: "téléchargement",
    component: (file: DocumentDto) => {
      return {
        component: "a",
        href: `${props.cdnUrl}${props.cdnUrl.endsWith("/") ? "" : "/"}${file.uuid}`,
        target: "_blank",
        rel: "noopener noreferrer",
        class: "fr-icon-file-download-fill",
        children: [
          {
            component: "span",
            class: "fr-sr-only",
            text: " - nouvel onglet",
          },
        ],
      };
    },
  },
];
</script>
